import { render, staticRenderFns } from "./shareList.vue?vue&type=template&id=da806e34&scoped=true"
import script from "./shareList.vue?vue&type=script&lang=js"
export * from "./shareList.vue?vue&type=script&lang=js"
import style0 from "./shareList.vue?vue&type=style&index=0&id=da806e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da806e34",
  null
  
)

export default component.exports